export default "__VITE_ASSET__BV$3AIQ0__"